// extracted by mini-css-extract-plugin
export var citeLink = "cite-module--citeLink--IIPaB";
export var citeWrapper = "cite-module--citeWrapper--GyyH-";